import axios from '@/libs/api.request'

export const GetOperateStore = data => {
  return axios.request({
    url: '/print/operate/store',
    params: data,
    method: 'get'
  })
}
export const GetOperate = data => {
  return axios.request({
    url: '/print/operate',
    params: data,
    method: 'get'
  })
}
export const AddOperate = data => {
  return axios.request({
    url: '/print/operate',
    data,
    method: 'put'
  })
}
export const ExcelOperateCode = data => {
  return axios.request({
    url: '/print/agent/operate/code_excel',
    data,
    method: 'post'
  })
}
